/**
 * Canonical PostHog event names for Flarecut (snake_case, object_action pattern).
 * Use these for all new instrumentation; legacy logEvent strings are normalized automatically.
 */
export const AnalyticsEvents = {
  // Auth
  LOGIN_SUBMITTED: "login_submitted",
  LOGIN_SUCCEEDED: "login_succeeded",
  LOGIN_FAILED: "login_failed",
  LOGIN_GOOGLE_CLICKED: "login_google_clicked",
  LOGIN_SIGNUP_LINK_CLICKED: "login_signup_link_clicked",
  LOGIN_PASSWORD_RESET_REQUESTED: "login_password_reset_requested",
  REGISTER_MODAL_OPENED: "register_modal_opened",
  REGISTER_MODAL_CLOSED: "register_modal_closed",
  REGISTER_SUBMITTED: "register_submitted",
  REGISTER_SUCCEEDED: "register_succeeded",
  REGISTER_FAILED: "register_failed",
  REGISTER_GOOGLE_CLICKED: "register_google_clicked",
  USER_IDENTIFIED: "user_identified",

  // Navigation
  NAV_LOGO_CLICKED: "nav_logo_clicked",
  NAV_PRICING_CLICKED: "nav_pricing_clicked",
  NAV_BLOG_CLICKED: "nav_blog_clicked",
  NAV_CONTACT_CLICKED: "nav_contact_clicked",
  NAV_AUTH_CLICKED: "nav_auth_clicked",
  NAV_MOBILE_MENU_TOGGLED: "nav_mobile_menu_toggled",
  LANGUAGE_SWITCHED: "language_switched",
  FOOTER_LINK_CLICKED: "footer_link_clicked",
  FOOTER_SOCIAL_CLICKED: "footer_social_clicked",
  FOOTER_EMAIL_CLICKED: "footer_email_clicked",

  // Homepage v2
  HOMEPAGE_CTA_CLICKED: "homepage_cta_clicked",
  HOMEPAGE_FAQ_TOGGLED: "homepage_faq_toggled",

  // Pricing & billing
  PRICING_BILLING_PERIOD_TOGGLED: "pricing_billing_period_toggled",
  PRICING_CHECKOUT_STARTED: "pricing_checkout_started",
  PRICING_CHECKOUT_FAILED: "pricing_checkout_failed",
  UPGRADE_MODAL_CONFIRMED: "upgrade_modal_confirmed",
  UPGRADE_MODAL_CANCELLED: "upgrade_modal_cancelled",
  UPGRADE_MODAL_COUPON_APPLIED: "upgrade_modal_coupon_applied",
  UPGRADE_MODAL_CLOSED: "upgrade_modal_closed",

  // API
  API_LOGIN_PROMPT_CLICKED: "api_login_prompt_clicked",
  API_TOKEN_GENERATED: "api_token_generated",
  API_TOKEN_REVOKED: "api_token_revoked",
  API_TOKEN_COPIED: "api_token_copied",

  // Dashboard & projects
  PROJECT_SELECTED: "project_selected",
  PROJECT_CREATED: "project_created",
  MEDIA_LIBRARY_OPENED: "media_library_opened",
  MEDIA_LIBRARY_CLOSED: "media_library_closed",
  MEDIA_LIBRARY_UPLOADED: "media_library_uploaded",
  MEDIA_LIBRARY_ITEM_DELETED: "media_library_item_deleted",

  // Video generator
  GENERATE_VIDEO_CLICKED: "generate_video_clicked",
  SHORT_GENERATION_STARTED: "short_generation_started",
  SHORT_GENERATION_COMPLETED: "short_generation_completed",
  SHORT_GENERATION_FAILED: "short_generation_failed",
  VIDEO_EXPORTED: "video_exported",
  VIDEO_GENERATOR_OPENED: "video_generator_opened",
  VIDEO_GENERATOR_REGENERATE_CLICKED: "video_generator_regenerate_clicked",

  // Homepage product picker
  VIDEO_TYPE_PICKER_OPENED: "video_type_picker_opened",
  VIDEO_TYPE_PICKER_CLOSED: "video_type_picker_closed",
  VIDEO_TYPE_SELECTED: "video_type_selected",

  // Landing page configurators
  LANDING_PAGE_GENERATE_CLICKED: "landing_page_generate_clicked",
  LANDING_PAGE_AUTH_GATE: "landing_page_auth_gate",
  LANDING_PAGE_AUTH_MODAL_OPENED: "landing_page_auth_modal_opened",
  LANDING_PAGE_AUTH_MODAL_CLOSED: "landing_page_auth_modal_closed",

  // Onboarding
  ONBOARDING_SOURCE_SUBMITTED: "onboarding_source_submitted",
  ONBOARDING_SOURCE_SKIPPED: "onboarding_source_skipped",
  ONBOARDING_SOURCE_MODAL_CLOSED: "onboarding_source_modal_closed",
  ONBOARDING_INTENT_SUBMITTED: "onboarding_intent_submitted",
  ONBOARDING_INTENT_SKIPPED: "onboarding_intent_skipped",
  ONBOARDING_INTENT_MODAL_CLOSED: "onboarding_intent_modal_closed",

  // Pricing
  PRICING_PAGE_VIEWED: "pricing_page_viewed",
  PRICING_PLAN_SELECTED: "pricing_plan_selected",

  // Pageviews
  PAGE_VIEWED: "$pageview",
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
